import { render, staticRenderFns } from "./VincularVoucher.vue?vue&type=template&id=255564e3"
import script from "./VincularVoucher.vue?vue&type=script&lang=js"
export * from "./VincularVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports